<div class="budgets-container">
  <div class="budgets-wrapper">
    <div class="budgets-header">
      <div class="budgets-title-row">
        <h3 class="budgets-title">Budgets</h3>
        <div class="report-actions">
          <button
            class="report-button report-pdf"
            title="Télécharger le rapport PTAB (PDF)"
            aria-label="Télécharger le rapport PTAB au format PDF"
            (click)="telechargerRapportPtab()"
          >
            <mat-icon>picture_as_pdf</mat-icon>
          </button>

          <button
            class="report-button report-xlsx"
            title="Télécharger le rapport PTAB (XLSX)"
            aria-label="Télécharger le rapport PTAB au format XLSX"
            (click)="telechargerRapportPtabXlsx()"
          >
            <mat-icon>table_chart</mat-icon>
          </button>
        </div>
      </div>

      <h4 class="budgets-subtitle">Gestion de vos activités</h4>
    </div>

    <div class="budgets-content">
      <div class="budgets-actions">
        <app-ui-button
          label="Ajouter un budget"
          variant="primary"
          iconLeft="add_circle_outline"
          (clicked)="ajouterBudget()"
        />
      </div>

      <div class="budgets-table">
        <app-ui-table [columns]="tableColumnBudgets" [data]="activities" />
      </div>
    </div>
  </div>
</div>